import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { EmployeeLayout } from '../../components/EmployeeLayout';
import { employeeAPI } from '../../lib/api';
import { Megaphone } from 'lucide-react';

function timeAgo(isoStr) {
  if (!isoStr) return '';
  const diff = Date.now() - new Date(isoStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(isoStr).toLocaleDateString();
}

export default function EmployeeAnnouncements() {
  const { user } = useAuth();
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.restaurant_id) {
      setLoading(false);
      return;
    }
    employeeAPI
      .getAnnouncements(user.restaurant_id)
      .then(res => setAnnouncements(res.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [user]);

  return (
    <EmployeeLayout>
      <div className="p-6 space-y-6" data-testid="employee-announcements">
        <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope' }}>
          Announcements
        </h1>

        {loading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-orange-500" />
          </div>
        ) : announcements.length === 0 ? (
          <div className="bg-white rounded-xl border border-slate-200 p-12 text-center">
            <Megaphone className="mx-auto text-slate-300 mb-3" size={40} />
            <p className="text-slate-500">No announcements yet.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {announcements.map(a => (
              <div
                key={a.id}
                className="bg-white rounded-xl border border-slate-200 shadow-sm p-5"
                data-testid="announcement-item"
              >
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Megaphone size={14} className="text-orange-600" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-slate-900">{a.title}</h3>
                    <p className="text-slate-600 text-sm mt-1.5 leading-relaxed">{a.message}</p>
                    <div className="flex items-center gap-2 mt-3 text-xs text-slate-400">
                      <span>Posted by {a.created_by_name}</span>
                      <span>·</span>
                      <span>{timeAgo(a.created_at)}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </EmployeeLayout>
  );
}
